import { jsx as c } from "react/jsx-runtime";
import { forwardRef as i } from "react";
import { css as m, cx as d } from "@/styled-system/css";
import { Slot as p } from "../../node_modules/.pnpm/@radix-ui_react-slot@1.1.0_@types_react@18.3.16_react@18.3.1/node_modules/@radix-ui/react-slot/dist/index.js";
const f = i(
  (s, o) => {
    const { asChild: n = !1, children: r, className: a, css: e, ...t } = s, l = m({ srOnly: !0 }, e);
    return /* @__PURE__ */ c(
      n ? p : "span",
      {
        className: d("c11n", l, a),
        "data-c11n-component": "VisuallyHidden",
        "data-c11n-version": "10.0.0-alpha.19",
        ref: o,
        ...t,
        children: r
      }
    );
  }
);
f.displayName = "VisuallyHidden";
export {
  f as VisuallyHidden
};
//# sourceMappingURL=visually-hidden.js.map
